import Icon from "@afa-shared/afa-components/dist/Icon";
import { ReactNode } from "react";

import pickerBoxStyles from "./PickerBox.module.css";

type IconSize = "sm" | "md" | "lg" | "xl";

export interface IPickerBox {
  label: string | ReactNode;
  iconName: any;
  iconSize?: IconSize;
  iconColor?: string;
  largeLabel?: boolean;
  clickablePickerBox?: boolean;
}

const PickerBox = ({ label, iconName, iconSize = "sm" }: IPickerBox): React.ReactNode => {
  return (
    <div className={pickerBoxStyles.pickerBox}>
      <span className={pickerBoxStyles.labelText}>{label}</span>
      <Icon size={iconSize} name={iconName as any} className={pickerBoxStyles.icon} />
    </div>
  );
};

export default PickerBox;
